import { jsx as _jsx } from "react/jsx-runtime";
import { Ban } from 'lucide-react';
import { createModulePerms } from '@wit-support/ui-domain';
import { BlacklistListPage } from './routes/list.js';
const { Provider: BlacklistModulePermsProvider, usePerms: useBlacklistPerms } = createModulePerms({ canManage: false });
export { BlacklistModulePermsProvider };
function BlacklistPageRoute() {
    const { canManage } = useBlacklistPerms();
    return _jsx(BlacklistListPage, { canManage: canManage });
}
export const blacklistModule = {
    id: 'blacklist',
    label: 'Чёрный список',
    icon: Ban,
    permission: 'blacklist.read',
    workspace: 'support',
    order: 92,
    description: 'Адреса спам-отправителей: их письма сохраняются, но не обрабатываются и не показываются.',
    showInNav: true,
    routes: [{ path: '/', component: BlacklistPageRoute }],
};
export { BlacklistListPage } from './routes/list.js';
export { setBlacklistApiBaseUrl } from './api.js';
//# sourceMappingURL=index.js.map